import { GridColumnProps } from '@progress/kendo-react-grid'
import { SubscriptionDetailsKey } from 'api/Trading-Accounts/Types/SubscriptionDetailsDto'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

export const subscriptionDetailColumns: GridColumn[] = [
  {
    title: 'Name',
    field: SubscriptionDetailsKey.name,
    minResizableWidth: 120,
    width: 120,
    show: true,
    filter: 'text',
  },
  {
    title: 'Description',
    field: SubscriptionDetailsKey.description,
    minResizableWidth: 120,
    width: 120,
    show: true,
    filter: 'text',
  },
  {
    title: 'Type',
    field: SubscriptionDetailsKey.type,
    minResizableWidth: 120,
    width: 120,
    show: true,
    filter: 'text',
  },
  {
    title: 'Amount',
    field: SubscriptionDetailsKey.amount,
    minResizableWidth: 120,
    width: 120,
    show: true,
    filter: 'text',
  },
  {
    title: 'MappingId',
    field: SubscriptionDetailsKey.mappingId,
    minResizableWidth: 120,
    width: 120,
    show: true,
    filter: 'text',
  },
  {
    title: 'MappingText',
    field: SubscriptionDetailsKey.mappingText,
    minResizableWidth: 120,
    width: 120,
    show: true,
    filter: 'text',
  },
]
